'use client'

import { Ssgoi, type SsgoiConfig } from '@ssgoi/react'
import { drill, fade } from '@ssgoi/react/view-transitions'
import { useMemo } from 'react'

// Per-route page transitions. Extension detail/list pages get iOS-style
// drill (parallax push in / pop out); everything else cross-fades.
export function TransitionProvider({ children }: { children: React.ReactNode }) {
	const config = useMemo<SsgoiConfig>(
		() => ({
			// ssgoi's symmetric helpers (`fade`, `drill`) generate one pair per
			// path *combination* — passing `['*']` makes a degenerate `*↔*`
			// self-pair that the matcher never picks. Enumerate real routes
			// instead. Drill order matters: declare it before fade so the
			// matcher prefers it for `/extensions/*` entries.
			transitions: [
				// List → detail drills (forward + back generated by helper).
				drill({ enter: '/extensions/*', exit: '/extensions/pending' }),
				drill({ enter: '/extensions/*', exit: '/' }),
				// Everything else cross-fades.
				fade({
					paths: ['/', '/profile', '/review', '/sync', '/extensions/pending', '/extensions/*'],
				}),
			],
		}),
		[],
	)
	// `relative z-0` is required by ssgoi: the outgoing page is positioned
	// absolute during the transition and needs a positioned ancestor.
	return (
		<Ssgoi config={config}>
			<div className="relative z-0">{children}</div>
		</Ssgoi>
	)
}
